import _ from "lodash";
import React, { useState } from "react";
import { Modal, Button, SelectDropdown, Tooltip } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";
import classes from "./EditStorageAccountModal.scss";
import { useI18n } from "Hooks";
import {
  GOOGLE_DRIVE_STORAGE_OPTION,
  MICORSOFT_DRIVE_STORAGE_OPTION,
} from "Tooling/modules/ToolingUtils";

const DRIVE_OPTIONS = [
  GOOGLE_DRIVE_STORAGE_OPTION,
  MICORSOFT_DRIVE_STORAGE_OPTION,
];
const styles = {
  overlayInnerStyle: {
    maxWidth: "256px",
    textAlign: "center",
  },
};

const EditStorageAccountModal = ({ onUpdate, closeModal }) => {
  const [storageOption, setStorageOption] = useState(
    GOOGLE_DRIVE_STORAGE_OPTION
  );
  const { t } = useI18n();

  const handleUpdateStorageAccount = () => {
    onUpdate(`["${_.get(storageOption, "value")}"]`);
  };
  return (
    <Modal hasOverlay onClose={closeModal} width={"456px"} height="fit-content">
      <Modal.Header
        title={t("onBoarding:edit_cloud_storge_account")}
        subtitle={t("onBoarding:sure_to_edit_cloud_storage_account")}
      ></Modal.Header>
      <Modal.Body>
        <div className={classes.bodyContainer}>
          <div className={classes.label}>
            <div className="text-label-2">
              {t("onBoarding:school_cloud_storage_account")}
            </div>
            <Tooltip
              tooltip={t(
                "onBoarding:school_cloud_storage_account_tooltip_info"
              )}
              overlayInnerStyle={styles.overlayInnerStyle}
              placement={"bottom"}
            >
              <InformationOutlined size={"xx-small"} />
            </Tooltip>
          </div>
          <SelectDropdown
            options={DRIVE_OPTIONS}
            onChange={setStorageOption}
            value={storageOption}
            isSelectAllEnabled={false}
            isClearable={false}
            isCreatable={false}
            size={"large"}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footer}>
          <Button variant="outlined-subtle" onClick={closeModal}>
            {t("common:cancel")}
          </Button>
          <Button onClick={handleUpdateStorageAccount}>
            {t("common:update")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditStorageAccountModal;
